import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import OrderController from '../controller/OrderController';

interface PropsType {
  lang: number;
  setLang: any;
}

const LangSelectBox = ({ lang, setLang }: PropsType) => {
  const [selectedValue, setSelectedValue] = useState<number>(lang);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const options = [
    { value: 0, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_kr.svg` },
    { value: 1, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_en.svg` },
    { value: 2, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_ch.svg` },
    { value: 3, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_ja.svg` },
    { value: 4, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_th.svg` },
    { value: 5, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_es.svg` },
    { value: 6, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_fr.svg` },
    { value: 7, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_ru.svg` },
    { value: 8, label: '', imgSrc: `${process.env.PUBLIC_URL}/svg/lang_de.svg` },
  ];
  const handleSelect = (value: number) => {
    setSelectedValue(value);
    setLang(value);
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedValue(lang);
  }, [lang]);
  return (
    <Style>
      <div className="customSelect">
        <div className="selectHeader" onClick={() => setIsOpen(!isOpen)}>
          {options.find((option) => option.value === selectedValue)?.imgSrc && (
            <img
              src={options.find((option) => option.value === selectedValue)?.imgSrc}
              alt="국기"
            />
          )}
          <span>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey.svg`} alt="전화 아이콘" />
          </span>
        </div>
        {isOpen && (
          <div className="selectOptions">
            {options.map((option) => (
              <div
                key={option.value}
                className={`selectOption ${selectedValue === option.value ? 'selected' : ''}`}
                onClick={() => handleSelect(option.value)}>
                <img src={option.imgSrc} alt="국기" />
              </div>
            ))}
          </div>
        )}
      </div>
    </Style>
  );
};

export default LangSelectBox;

export const Style = styled.div`
  /* customSelect */
  .customSelect {
    width: auto;
    background: #fff;
    border-radius: 8px;
    position: relative;
    display: inline-flex;
  }
  .selectHeader {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px 4px 18px;

    img {
      width: 22px;
      height: 22px;
    }
  }
  .selectOptions {
    position: absolute;
    left: 0;
    top: 86%;
    min-width: 100%;
    background: #fff;

    img {
      padding: 8px 0 8px 0px;
      width: 40px;
      height: 40px;
    }
  }
  .selectOption {
    padding: 0px 10px;
  }
  .selectOption.selected {
    background: #ecf5f3;
  }
`;
